export default __webpack_public_path__ + "static/media/PM_LOGO_FINAL-02.aa36dbf1.png";